//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from 'rxjs/operators';
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from '@angular/common/http';

import moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AuthenticationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * @param body (optional)
   * @return OK
   */
  login(body: LoginRequestDto | undefined): Observable<LoginResponseDto> {
    let url_ = this.baseUrl + '/api/Authentication/Login';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLogin(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLogin(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LoginResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<LoginResponseDto>;
        })
      );
  }

  protected processLogin(
    response: HttpResponseBase
  ): Observable<LoginResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LoginResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LoginResponseDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  verifyOtp(body: LoginRequestDto | undefined): Observable<LoginResponseDto> {
    let url_ = this.baseUrl + '/api/Authentication/VerifyOtp';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processVerifyOtp(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processVerifyOtp(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LoginResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<LoginResponseDto>;
        })
      );
  }

  protected processVerifyOtp(
    response: HttpResponseBase
  ): Observable<LoginResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = LoginResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LoginResponseDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  forgetPassword(
    body: ForgotPasswordRequestDto | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/Authentication/ForgetPassword';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processForgetPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processForgetPassword(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processForgetPassword(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  resetPasswordWithToken(
    body: ResetPasswordRequestWithTokenDto | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/Authentication/ResetPasswordWithToken';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetPasswordWithToken(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetPasswordWithToken(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processResetPasswordWithToken(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  changePassword(
    body: ResetPasswordRequestDto | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/Authentication/ChangePassword';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePassword(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processChangePassword(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @param token (optional)
   * @return OK
   */
  verifyPasswordResetTokenExpiry(
    token: string | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ =
      this.baseUrl + '/api/Authentication/VerifyPasswordResetTokenExpiry?';
    if (token === null)
      throw new Error("The parameter 'token' cannot be null.");
    else if (token !== undefined)
      url_ += 'token=' + encodeURIComponent('' + token) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processVerifyPasswordResetTokenExpiry(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processVerifyPasswordResetTokenExpiry(
                response_ as any
              );
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processVerifyPasswordResetTokenExpiry(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }
}

@Injectable()
export class LogsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * @param searchTerm (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param cleverStatusId (optional)
   * @param isOnboarded (optional)
   * @return OK
   */
  getAllReferralPatientLogs(
    searchTerm: string | undefined,
    pageNumber: number | undefined,
    pageSize: number | undefined,
    cleverStatusId: number | undefined,
    isOnboarded: boolean | undefined
  ): Observable<CommonGridResponseDto> {
    let url_ = this.baseUrl + '/api/Logs/GetAllReferralPatientLogs?';
    if (searchTerm === null)
      throw new Error("The parameter 'searchTerm' cannot be null.");
    else if (searchTerm !== undefined)
      url_ += 'SearchTerm=' + encodeURIComponent('' + searchTerm) + '&';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (cleverStatusId === null)
      throw new Error("The parameter 'cleverStatusId' cannot be null.");
    else if (cleverStatusId !== undefined)
      url_ += 'CleverStatusId=' + encodeURIComponent('' + cleverStatusId) + '&';
    if (isOnboarded === null)
      throw new Error("The parameter 'isOnboarded' cannot be null.");
    else if (isOnboarded !== undefined)
      url_ += 'IsOnboarded=' + encodeURIComponent('' + isOnboarded) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllReferralPatientLogs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllReferralPatientLogs(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<CommonGridResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CommonGridResponseDto>;
        })
      );
  }

  protected processGetAllReferralPatientLogs(
    response: HttpResponseBase
  ): Observable<CommonGridResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CommonGridResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CommonGridResponseDto>(null as any);
  }

  /**
   * @param patientId (optional)
   * @return OK
   */
  getReferralPatientLog(
    patientId: number | undefined
  ): Observable<ReferralPatientLogDto> {
    let url_ = this.baseUrl + '/api/Logs/GetReferralPatientLog?';
    if (patientId === null)
      throw new Error("The parameter 'patientId' cannot be null.");
    else if (patientId !== undefined)
      url_ += 'patientId=' + encodeURIComponent('' + patientId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReferralPatientLog(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReferralPatientLog(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ReferralPatientLogDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ReferralPatientLogDto>;
        })
      );
  }

  protected processGetReferralPatientLog(
    response: HttpResponseBase
  ): Observable<ReferralPatientLogDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReferralPatientLogDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ReferralPatientLogDto>(null as any);
  }
}

@Injectable()
export class MasterServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * @param body (optional)
   * @return OK
   */
  insertModeOfConsumption(
    body: ModeOfConsumptionDto | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/Master/InsertModeOfConsumption';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processInsertModeOfConsumption(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processInsertModeOfConsumption(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processInsertModeOfConsumption(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  updateModeOfConsumption(
    body: ModeOfConsumptionDto | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/Master/UpdateModeOfConsumption';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateModeOfConsumption(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateModeOfConsumption(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processUpdateModeOfConsumption(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @return OK
   */
  deleteModeOfConsumption(id: number): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/Master/DeleteModeOfConsumption/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteModeOfConsumption(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteModeOfConsumption(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processDeleteModeOfConsumption(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @return OK
   */
  getAllModeOfConsumption(
    pageNumber: number | undefined,
    pageSize: number | undefined
  ): Observable<ModeOfConsumptionResponseDto> {
    let url_ = this.baseUrl + '/api/Master/GetAllModeOfConsumption?';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllModeOfConsumption(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllModeOfConsumption(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ModeOfConsumptionResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ModeOfConsumptionResponseDto>;
        })
      );
  }

  protected processGetAllModeOfConsumption(
    response: HttpResponseBase
  ): Observable<ModeOfConsumptionResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ModeOfConsumptionResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ModeOfConsumptionResponseDto>(null as any);
  }

  /**
   * @param typeId (optional)
   * @param providerId (optional)
   * @return OK
   */
  getAllModeOfConsumptionByTypeIdProviderId(
    typeId: number | undefined,
    providerId: number | undefined
  ): Observable<ModeOfConsumptionDto[]> {
    let url_ =
      this.baseUrl + '/api/Master/GetAllModeOfConsumptionByTypeIdProviderId?';
    if (typeId === null)
      throw new Error("The parameter 'typeId' cannot be null.");
    else if (typeId !== undefined)
      url_ += 'TypeId=' + encodeURIComponent('' + typeId) + '&';
    if (providerId === null)
      throw new Error("The parameter 'providerId' cannot be null.");
    else if (providerId !== undefined)
      url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllModeOfConsumptionByTypeIdProviderId(
            response_
          );
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllModeOfConsumptionByTypeIdProviderId(
                response_ as any
              );
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                ModeOfConsumptionDto[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              ModeOfConsumptionDto[]
            >;
        })
      );
  }

  protected processGetAllModeOfConsumptionByTypeIdProviderId(
    response: HttpResponseBase
  ): Observable<ModeOfConsumptionDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ModeOfConsumptionDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ModeOfConsumptionDto[]>();
  }

  /**
   * @param body (optional)
   * @return OK
   */
  addHealthInsuranceType(
    body: HealthInsuranceTypeDto | undefined
  ): Observable<number> {
    let url_ = this.baseUrl + '/api/Master/AddHealthInsuranceType';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddHealthInsuranceType(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddHealthInsuranceType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processAddHealthInsuranceType(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  updateHealthInsuranceType(
    body: HealthInsuranceTypeDto | undefined
  ): Observable<number> {
    let url_ = this.baseUrl + '/api/Master/UpdateHealthInsuranceType';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateHealthInsuranceType(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateHealthInsuranceType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processUpdateHealthInsuranceType(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * @return OK
   */
  deleteHealthInsuranceType(id: number): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/Master/DeleteHealthInsuranceType/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteHealthInsuranceType(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteHealthInsuranceType(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processDeleteHealthInsuranceType(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @return OK
   */
  getAllHealthInsuranceTypes(
    pageNumber: number | undefined,
    pageSize: number | undefined
  ): Observable<HealthInsuranceTypeResponseDto> {
    let url_ = this.baseUrl + '/api/Master/GetAllHealthInsuranceTypes?';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllHealthInsuranceTypes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllHealthInsuranceTypes(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<HealthInsuranceTypeResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<HealthInsuranceTypeResponseDto>;
        })
      );
  }

  protected processGetAllHealthInsuranceTypes(
    response: HttpResponseBase
  ): Observable<HealthInsuranceTypeResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = HealthInsuranceTypeResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<HealthInsuranceTypeResponseDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  addHealthInsuranceProvider(
    body: HealthInsuranceProviderDto | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/Master/AddHealthInsuranceProvider';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddHealthInsuranceProvider(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddHealthInsuranceProvider(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processAddHealthInsuranceProvider(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  updateHealthInsuranceProvider(
    body: HealthInsuranceProviderDto | undefined
  ): Observable<number> {
    let url_ = this.baseUrl + '/api/Master/UpdateHealthInsuranceProvider';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateHealthInsuranceProvider(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateHealthInsuranceProvider(
                response_ as any
              );
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processUpdateHealthInsuranceProvider(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * @return OK
   */
  deleteHealthInsuranceProvider(id: number): Observable<number> {
    let url_ = this.baseUrl + '/api/Master/DeleteHealthInsuranceProvider/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteHealthInsuranceProvider(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteHealthInsuranceProvider(
                response_ as any
              );
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processDeleteHealthInsuranceProvider(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @return OK
   */
  getAllHealthInsuranceProviders(
    pageNumber: number | undefined,
    pageSize: number | undefined
  ): Observable<HealthInsuranceProviderResponseDto> {
    let url_ = this.baseUrl + '/api/Master/GetAllHealthInsuranceProviders?';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllHealthInsuranceProviders(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllHealthInsuranceProviders(
                response_ as any
              );
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<HealthInsuranceProviderResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<HealthInsuranceProviderResponseDto>;
        })
      );
  }

  protected processGetAllHealthInsuranceProviders(
    response: HttpResponseBase
  ): Observable<HealthInsuranceProviderResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = HealthInsuranceProviderResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<HealthInsuranceProviderResponseDto>(null as any);
  }

  /**
   * @return OK
   */
  getHealthInsuranceProvidersByTypeId(
    id: number
  ): Observable<HealthInsuranceProviderDto[]> {
    let url_ =
      this.baseUrl + '/api/Master/GetHealthInsuranceProvidersByTypeId/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetHealthInsuranceProvidersByTypeId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetHealthInsuranceProvidersByTypeId(
                response_ as any
              );
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                HealthInsuranceProviderDto[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              HealthInsuranceProviderDto[]
            >;
        })
      );
  }

  protected processGetHealthInsuranceProvidersByTypeId(
    response: HttpResponseBase
  ): Observable<HealthInsuranceProviderDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(HealthInsuranceProviderDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<HealthInsuranceProviderDto[]>();
  }

  /**
   * @return OK
   */
  getAllCleverStatus(): Observable<CleverStatusResponseDto[]> {
    let url_ = this.baseUrl + '/api/Master/GetAllCleverStatus';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllCleverStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllCleverStatus(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                CleverStatusResponseDto[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              CleverStatusResponseDto[]
            >;
        })
      );
  }

  protected processGetAllCleverStatus(
    response: HttpResponseBase
  ): Observable<CleverStatusResponseDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(CleverStatusResponseDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CleverStatusResponseDto[]>();
  }

  /**
   * @return OK
   */
  getCleverStatusById(id: number): Observable<CleverStatusDto> {
    let url_ = this.baseUrl + '/api/Master/GetCleverStatusById/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCleverStatusById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCleverStatusById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CleverStatusDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CleverStatusDto>;
        })
      );
  }

  protected processGetCleverStatusById(
    response: HttpResponseBase
  ): Observable<CleverStatusDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CleverStatusDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CleverStatusDto>(null as any);
  }
}

@Injectable()
export class OrganizationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @return OK
   */
  getAll(
    pageNumber: number | undefined,
    pageSize: number | undefined
  ): Observable<OrganizationsResponseDto> {
    let url_ = this.baseUrl + '/api/Organization/GetAll?';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<OrganizationsResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<OrganizationsResponseDto>;
        })
      );
  }

  protected processGetAll(
    response: HttpResponseBase
  ): Observable<OrganizationsResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OrganizationsResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<OrganizationsResponseDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  addOrganization(
    body: OrganizationDto | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/Organization/AddOrganization';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddOrganization(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddOrganization(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processAddOrganization(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  updateOrganization(
    body: OrganizationDto | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/Organization/UpdateOrganization';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateOrganization(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateOrganization(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processUpdateOrganization(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @return OK
   */
  getOrganizationById(id: number): Observable<OrganizationDto> {
    let url_ = this.baseUrl + '/api/Organization/GetOrganizationById/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetOrganizationById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetOrganizationById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OrganizationDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<OrganizationDto>;
        })
      );
  }

  protected processGetOrganizationById(
    response: HttpResponseBase
  ): Observable<OrganizationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OrganizationDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<OrganizationDto>(null as any);
  }

  /**
   * @return OK
   */
  deleteOrganization(id: number): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/Organization/DeleteOrganization/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteOrganization(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteOrganization(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processDeleteOrganization(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }
}

@Injectable()
export class PatientReferralServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * @param body (optional)
   * @return OK
   */
  createPatient(
    body: PatientRequestDto | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/PatientReferral/CreatePatient';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreatePatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreatePatient(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processCreatePatient(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @param searchTerm (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param cleverStatusId (optional)
   * @param isOnboarded (optional)
   * @return OK
   */
  getAllReferralPatient(
    searchTerm: string | undefined,
    pageNumber: number | undefined,
    pageSize: number | undefined,
    cleverStatusId: number | undefined,
    isOnboarded: boolean | undefined
  ): Observable<CommonGridResponseDto> {
    let url_ = this.baseUrl + '/api/PatientReferral/GetAllReferralPatient?';
    if (searchTerm === null)
      throw new Error("The parameter 'searchTerm' cannot be null.");
    else if (searchTerm !== undefined)
      url_ += 'SearchTerm=' + encodeURIComponent('' + searchTerm) + '&';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (cleverStatusId === null)
      throw new Error("The parameter 'cleverStatusId' cannot be null.");
    else if (cleverStatusId !== undefined)
      url_ += 'CleverStatusId=' + encodeURIComponent('' + cleverStatusId) + '&';
    if (isOnboarded === null)
      throw new Error("The parameter 'isOnboarded' cannot be null.");
    else if (isOnboarded !== undefined)
      url_ += 'IsOnboarded=' + encodeURIComponent('' + isOnboarded) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllReferralPatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllReferralPatient(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<CommonGridResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CommonGridResponseDto>;
        })
      );
  }

  protected processGetAllReferralPatient(
    response: HttpResponseBase
  ): Observable<CommonGridResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CommonGridResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CommonGridResponseDto>(null as any);
  }

  /**
   * @param searchTerm (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @return OK
   */
  getAllReferralPatientByCurrentUser(
    searchTerm: string | undefined,
    pageNumber: number | undefined,
    pageSize: number | undefined
  ): Observable<CommonGridResponseDto> {
    let url_ =
      this.baseUrl + '/api/PatientReferral/GetAllReferralPatientByCurrentUser?';
    if (searchTerm === null)
      throw new Error("The parameter 'searchTerm' cannot be null.");
    else if (searchTerm !== undefined)
      url_ += 'SearchTerm=' + encodeURIComponent('' + searchTerm) + '&';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllReferralPatientByCurrentUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllReferralPatientByCurrentUser(
                response_ as any
              );
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<CommonGridResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CommonGridResponseDto>;
        })
      );
  }

  protected processGetAllReferralPatientByCurrentUser(
    response: HttpResponseBase
  ): Observable<CommonGridResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CommonGridResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CommonGridResponseDto>(null as any);
  }

  /**
   * @return OK
   */
  getTotalReferralCount(): Observable<number> {
    let url_ = this.baseUrl + '/api/PatientReferral/GetTotalReferralCount';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTotalReferralCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTotalReferralCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processGetTotalReferralCount(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * @return OK
   */
  getReferralPatientById(id: number): Observable<PatientRequestDto> {
    let url_ =
      this.baseUrl + '/api/PatientReferral/GetReferralPatientById/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetReferralPatientById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetReferralPatientById(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PatientRequestDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PatientRequestDto>;
        })
      );
  }

  protected processGetReferralPatientById(
    response: HttpResponseBase
  ): Observable<PatientRequestDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PatientRequestDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PatientRequestDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  updatePatient(
    body: PatientRequestDto | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/PatientReferral/UpdatePatient';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePatient(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePatient(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processUpdatePatient(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @param patientIds (optional)
   * @param isOnboarded (optional)
   * @return OK
   */
  updatePatientOnboardingStatus(
    patientIds: string | undefined,
    isOnboarded: boolean | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ =
      this.baseUrl + '/api/PatientReferral/UpdatePatientOnboardingStatus?';
    if (patientIds === null)
      throw new Error("The parameter 'patientIds' cannot be null.");
    else if (patientIds !== undefined)
      url_ += 'patientIds=' + encodeURIComponent('' + patientIds) + '&';
    if (isOnboarded === null)
      throw new Error("The parameter 'isOnboarded' cannot be null.");
    else if (isOnboarded !== undefined)
      url_ += 'isOnboarded=' + encodeURIComponent('' + isOnboarded) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdatePatientOnboardingStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdatePatientOnboardingStatus(
                response_ as any
              );
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processUpdatePatientOnboardingStatus(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @return OK
   */
  uploadStream(): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/PatientReferral/upload-stream';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadStream(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadStream(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processUploadStream(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }
}

@Injectable()
export class UserServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? '';
  }

  /**
   * @param body (optional)
   * @return OK
   */
  register(
    body: UserRegistrationDto | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/User/Register';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRegister(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRegister(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processRegister(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @return OK
   */
  getUserProfile(): Observable<UserProfileResponseDto> {
    let url_ = this.baseUrl + '/api/User/GetUserProfile';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserProfile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserProfile(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<UserProfileResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<UserProfileResponseDto>;
        })
      );
  }

  protected processGetUserProfile(
    response: HttpResponseBase
  ): Observable<UserProfileResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserProfileResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserProfileResponseDto>(null as any);
  }

  /**
   * @return OK
   */
  getTotalUsersCount(): Observable<number> {
    let url_ = this.baseUrl + '/api/User/GetTotalUsersCount';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTotalUsersCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTotalUsersCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else
            return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processGetTotalUsersCount(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * @param searchTerm (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @return OK
   */
  getAllUser(
    searchTerm: string | undefined,
    pageNumber: number | undefined,
    pageSize: number | undefined
  ): Observable<CommonGridResponseDto> {
    let url_ = this.baseUrl + '/api/User/GetAllUser?';
    if (searchTerm === null)
      throw new Error("The parameter 'searchTerm' cannot be null.");
    else if (searchTerm !== undefined)
      url_ += 'SearchTerm=' + encodeURIComponent('' + searchTerm) + '&';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllUser(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<CommonGridResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CommonGridResponseDto>;
        })
      );
  }

  protected processGetAllUser(
    response: HttpResponseBase
  ): Observable<CommonGridResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CommonGridResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CommonGridResponseDto>(null as any);
  }

  /**
   * @param userId (optional)
   * @return OK
   */
  getUserByUserId(userId: number | undefined): Observable<UserProfileDto> {
    let url_ = this.baseUrl + '/api/User/GetUserByUserId?';
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserByUserId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserByUserId(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserProfileDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<UserProfileDto>;
        })
      );
  }

  protected processGetUserByUserId(
    response: HttpResponseBase
  ): Observable<UserProfileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserProfileDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserProfileDto>(null as any);
  }

  /**
   * @param userId (optional)
   * @param isUserOTPApplicable (optional)
   * @return OK
   */
  updateUserTOTPInfo(
    userId: number | undefined,
    isUserOTPApplicable: boolean | undefined
  ): Observable<NutriciaCommonResponseDto> {
    let url_ = this.baseUrl + '/api/User/UpdateUserTOTPInfo?';
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    if (isUserOTPApplicable === null)
      throw new Error("The parameter 'isUserOTPApplicable' cannot be null.");
    else if (isUserOTPApplicable !== undefined)
      url_ +=
        'IsUserOTPApplicable=' +
        encodeURIComponent('' + isUserOTPApplicable) +
        '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUserTOTPInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUserTOTPInfo(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<NutriciaCommonResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<NutriciaCommonResponseDto>;
        })
      );
  }

  protected processUpdateUserTOTPInfo(
    response: HttpResponseBase
  ): Observable<NutriciaCommonResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NutriciaCommonResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<NutriciaCommonResponseDto>(null as any);
  }

  /**
   * @param organizationId (optional)
   * @return OK
   */
  getAllUserByOrganizationId(
    organizationId: number | undefined
  ): Observable<CommonGridResponseDto> {
    let url_ = this.baseUrl + '/api/User/GetAllUserByOrganizationId?';
    if (organizationId === null)
      throw new Error("The parameter 'organizationId' cannot be null.");
    else if (organizationId !== undefined)
      url_ += 'OrganizationId=' + encodeURIComponent('' + organizationId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllUserByOrganizationId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllUserByOrganizationId(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<CommonGridResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<CommonGridResponseDto>;
        })
      );
  }

  protected processGetAllUserByOrganizationId(
    response: HttpResponseBase
  ): Observable<CommonGridResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CommonGridResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CommonGridResponseDto>(null as any);
  }
}

export class CleverStatusDto implements ICleverStatusDto {
  id!: number;
  name!: string | undefined;
  description!: string | undefined;

  constructor(data?: ICleverStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): CleverStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new CleverStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    return data;
  }

  clone(): CleverStatusDto {
    const json = this.toJSON();
    let result = new CleverStatusDto();
    result.init(json);
    return result;
  }
}

export interface ICleverStatusDto {
  id: number;
  name: string | undefined;
  description: string | undefined;
}

export class CleverStatusResponseDto implements ICleverStatusResponseDto {
  cleverStatus!: CleverStatusDto[] | undefined;

  constructor(data?: ICleverStatusResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['cleverStatus'])) {
        this.cleverStatus = [] as any;
        for (let item of _data['cleverStatus'])
          this.cleverStatus!.push(CleverStatusDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CleverStatusResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new CleverStatusResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.cleverStatus)) {
      data['cleverStatus'] = [];
      for (let item of this.cleverStatus)
        data['cleverStatus'].push(item.toJSON());
    }
    return data;
  }

  clone(): CleverStatusResponseDto {
    const json = this.toJSON();
    let result = new CleverStatusResponseDto();
    result.init(json);
    return result;
  }
}

export interface ICleverStatusResponseDto {
  cleverStatus: CleverStatusDto[] | undefined;
}

export class CommonGridResponseDto implements ICommonGridResponseDto {
  data!: any | undefined;
  totalCount!: number;

  constructor(data?: ICommonGridResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.data = _data['data'];
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(data: any): CommonGridResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new CommonGridResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['data'] = this.data;
    data['totalCount'] = this.totalCount;
    return data;
  }

  clone(): CommonGridResponseDto {
    const json = this.toJSON();
    let result = new CommonGridResponseDto();
    result.init(json);
    return result;
  }
}

export interface ICommonGridResponseDto {
  data: any | undefined;
  totalCount: number;
}

export enum CustomResponseEnums {
  _101 = 101,
  _102 = 102,
  _103 = 103,
  _104 = 104,
  _105 = 105,
  _106 = 106,
  _107 = 107,
  _108 = 108,
  _200 = 200,
}

export class ForgotPasswordRequestDto implements IForgotPasswordRequestDto {
  emailAddress!: string | undefined;

  constructor(data?: IForgotPasswordRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data['emailAddress'];
    }
  }

  static fromJS(data: any): ForgotPasswordRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new ForgotPasswordRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['emailAddress'] = this.emailAddress;
    return data;
  }

  clone(): ForgotPasswordRequestDto {
    const json = this.toJSON();
    let result = new ForgotPasswordRequestDto();
    result.init(json);
    return result;
  }
}

export interface IForgotPasswordRequestDto {
  emailAddress: string | undefined;
}

export class HealthInsuranceProviderDto implements IHealthInsuranceProviderDto {
  id!: number;
  name!: string | undefined;
  description!: string | undefined;
  healthInsuranceTypeId!: number;

  constructor(data?: IHealthInsuranceProviderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.healthInsuranceTypeId = _data['healthInsuranceTypeId'];
    }
  }

  static fromJS(data: any): HealthInsuranceProviderDto {
    data = typeof data === 'object' ? data : {};
    let result = new HealthInsuranceProviderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['healthInsuranceTypeId'] = this.healthInsuranceTypeId;
    return data;
  }

  clone(): HealthInsuranceProviderDto {
    const json = this.toJSON();
    let result = new HealthInsuranceProviderDto();
    result.init(json);
    return result;
  }
}

export interface IHealthInsuranceProviderDto {
  id: number;
  name: string | undefined;
  description: string | undefined;
  healthInsuranceTypeId: number;
}

export class HealthInsuranceProviderResponseDto
  implements IHealthInsuranceProviderResponseDto
{
  healthInsuranceProviders!: HealthInsuranceProviderDto[] | undefined;
  totalCount!: number;

  constructor(data?: IHealthInsuranceProviderResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['healthInsuranceProviders'])) {
        this.healthInsuranceProviders = [] as any;
        for (let item of _data['healthInsuranceProviders'])
          this.healthInsuranceProviders!.push(
            HealthInsuranceProviderDto.fromJS(item)
          );
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(data: any): HealthInsuranceProviderResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new HealthInsuranceProviderResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.healthInsuranceProviders)) {
      data['healthInsuranceProviders'] = [];
      for (let item of this.healthInsuranceProviders)
        data['healthInsuranceProviders'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }

  clone(): HealthInsuranceProviderResponseDto {
    const json = this.toJSON();
    let result = new HealthInsuranceProviderResponseDto();
    result.init(json);
    return result;
  }
}

export interface IHealthInsuranceProviderResponseDto {
  healthInsuranceProviders: HealthInsuranceProviderDto[] | undefined;
  totalCount: number;
}

export class HealthInsuranceTypeDto implements IHealthInsuranceTypeDto {
  id!: number;
  name!: string | undefined;
  description!: string | undefined;

  constructor(data?: IHealthInsuranceTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): HealthInsuranceTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new HealthInsuranceTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    return data;
  }

  clone(): HealthInsuranceTypeDto {
    const json = this.toJSON();
    let result = new HealthInsuranceTypeDto();
    result.init(json);
    return result;
  }
}

export interface IHealthInsuranceTypeDto {
  id: number;
  name: string | undefined;
  description: string | undefined;
}

export class HealthInsuranceTypeResponseDto
  implements IHealthInsuranceTypeResponseDto
{
  healthInsuranceTypes!: HealthInsuranceTypeDto[] | undefined;
  totalCount!: number;

  constructor(data?: IHealthInsuranceTypeResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['healthInsuranceTypes'])) {
        this.healthInsuranceTypes = [] as any;
        for (let item of _data['healthInsuranceTypes'])
          this.healthInsuranceTypes!.push(HealthInsuranceTypeDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(data: any): HealthInsuranceTypeResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new HealthInsuranceTypeResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.healthInsuranceTypes)) {
      data['healthInsuranceTypes'] = [];
      for (let item of this.healthInsuranceTypes)
        data['healthInsuranceTypes'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }

  clone(): HealthInsuranceTypeResponseDto {
    const json = this.toJSON();
    let result = new HealthInsuranceTypeResponseDto();
    result.init(json);
    return result;
  }
}

export interface IHealthInsuranceTypeResponseDto {
  healthInsuranceTypes: HealthInsuranceTypeDto[] | undefined;
  totalCount: number;
}

export class LoginRequestDto implements ILoginRequestDto {
  userProvidedOTP!: string | undefined;
  username!: string | undefined;
  password!: string | undefined;

  constructor(data?: ILoginRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userProvidedOTP = _data['userProvidedOTP'];
      this.username = _data['username'];
      this.password = _data['password'];
    }
  }

  static fromJS(data: any): LoginRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new LoginRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userProvidedOTP'] = this.userProvidedOTP;
    data['username'] = this.username;
    data['password'] = this.password;
    return data;
  }

  clone(): LoginRequestDto {
    const json = this.toJSON();
    let result = new LoginRequestDto();
    result.init(json);
    return result;
  }
}

export interface ILoginRequestDto {
  userProvidedOTP: string | undefined;
  username: string | undefined;
  password: string | undefined;
}

export class LoginResponseDto implements ILoginResponseDto {
  userId!: number;
  isOTPApplicable!: boolean;
  isQRAlreadyGenerated!: boolean;
  token!: string | undefined;
  otpqrCode!: string | undefined;
  organizationId!: number;
  organizationName!: string | undefined;
  roleId!: number;
  roleName!: string | undefined;

  constructor(data?: ILoginResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.isOTPApplicable = _data['isOTPApplicable'];
      this.isQRAlreadyGenerated = _data['isQRAlreadyGenerated'];
      this.token = _data['token'];
      this.otpqrCode = _data['otpqrCode'];
      this.organizationId = _data['organizationId'];
      this.organizationName = _data['organizationName'];
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
    }
  }

  static fromJS(data: any): LoginResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new LoginResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['isOTPApplicable'] = this.isOTPApplicable;
    data['isQRAlreadyGenerated'] = this.isQRAlreadyGenerated;
    data['token'] = this.token;
    data['otpqrCode'] = this.otpqrCode;
    data['organizationId'] = this.organizationId;
    data['organizationName'] = this.organizationName;
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    return data;
  }

  clone(): LoginResponseDto {
    const json = this.toJSON();
    let result = new LoginResponseDto();
    result.init(json);
    return result;
  }
}

export interface ILoginResponseDto {
  userId: number;
  isOTPApplicable: boolean;
  isQRAlreadyGenerated: boolean;
  token: string | undefined;
  otpqrCode: string | undefined;
  organizationId: number;
  organizationName: string | undefined;
  roleId: number;
  roleName: string | undefined;
}

export class ModeOfConsumptionDto implements IModeOfConsumptionDto {
  id!: number;
  healthInsuranceTypeId!: number;
  healthInsuranceProviderId!: number | undefined;
  name!: string | undefined;
  description!: string | undefined;

  constructor(data?: IModeOfConsumptionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.healthInsuranceTypeId = _data['healthInsuranceTypeId'];
      this.healthInsuranceProviderId = _data['healthInsuranceProviderId'];
      this.name = _data['name'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): ModeOfConsumptionDto {
    data = typeof data === 'object' ? data : {};
    let result = new ModeOfConsumptionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['healthInsuranceTypeId'] = this.healthInsuranceTypeId;
    data['healthInsuranceProviderId'] = this.healthInsuranceProviderId;
    data['name'] = this.name;
    data['description'] = this.description;
    return data;
  }

  clone(): ModeOfConsumptionDto {
    const json = this.toJSON();
    let result = new ModeOfConsumptionDto();
    result.init(json);
    return result;
  }
}

export interface IModeOfConsumptionDto {
  id: number;
  healthInsuranceTypeId: number;
  healthInsuranceProviderId: number | undefined;
  name: string | undefined;
  description: string | undefined;
}

export class ModeOfConsumptionResponseDto
  implements IModeOfConsumptionResponseDto
{
  modeOfConsumptions!: ModeOfConsumptionDto[] | undefined;
  totalCount!: number;

  constructor(data?: IModeOfConsumptionResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['modeOfConsumptions'])) {
        this.modeOfConsumptions = [] as any;
        for (let item of _data['modeOfConsumptions'])
          this.modeOfConsumptions!.push(ModeOfConsumptionDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(data: any): ModeOfConsumptionResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new ModeOfConsumptionResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.modeOfConsumptions)) {
      data['modeOfConsumptions'] = [];
      for (let item of this.modeOfConsumptions)
        data['modeOfConsumptions'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }

  clone(): ModeOfConsumptionResponseDto {
    const json = this.toJSON();
    let result = new ModeOfConsumptionResponseDto();
    result.init(json);
    return result;
  }
}

export interface IModeOfConsumptionResponseDto {
  modeOfConsumptions: ModeOfConsumptionDto[] | undefined;
  totalCount: number;
}

export class NutriciaCommonResponseDto implements INutriciaCommonResponseDto {
  id!: number;
  statusCode!: CustomResponseEnums;
  cleverStatusId!: number;
  cleverStatus!: string | undefined;
  data!: any | undefined;
  readonly message!: string | undefined;

  constructor(data?: INutriciaCommonResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.statusCode = _data['statusCode'];
      this.cleverStatusId = _data['cleverStatusId'];
      this.cleverStatus = _data['cleverStatus'];
      this.data = _data['data'];
      (<any>this).message = _data['message'];
    }
  }

  static fromJS(data: any): NutriciaCommonResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new NutriciaCommonResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['statusCode'] = this.statusCode;
    data['cleverStatusId'] = this.cleverStatusId;
    data['cleverStatus'] = this.cleverStatus;
    data['data'] = this.data;
    data['message'] = this.message;
    return data;
  }

  clone(): NutriciaCommonResponseDto {
    const json = this.toJSON();
    let result = new NutriciaCommonResponseDto();
    result.init(json);
    return result;
  }
}

export interface INutriciaCommonResponseDto {
  id: number;
  statusCode: CustomResponseEnums;
  cleverStatusId: number;
  cleverStatus: string | undefined;
  data: any | undefined;
  message: string | undefined;
}

export class OrganizationDto implements IOrganizationDto {
  id!: number;
  organizationName!: string | undefined;
  isOTPApplicable!: boolean;

  constructor(data?: IOrganizationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.organizationName = _data['organizationName'];
      this.isOTPApplicable = _data['isOTPApplicable'];
    }
  }

  static fromJS(data: any): OrganizationDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['organizationName'] = this.organizationName;
    data['isOTPApplicable'] = this.isOTPApplicable;
    return data;
  }

  clone(): OrganizationDto {
    const json = this.toJSON();
    let result = new OrganizationDto();
    result.init(json);
    return result;
  }
}

export interface IOrganizationDto {
  id: number;
  organizationName: string | undefined;
  isOTPApplicable: boolean;
}

export class OrganizationsResponseDto implements IOrganizationsResponseDto {
  organzations!: OrganizationDto[] | undefined;
  totalCount!: number;

  constructor(data?: IOrganizationsResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['organzations'])) {
        this.organzations = [] as any;
        for (let item of _data['organzations'])
          this.organzations!.push(OrganizationDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(data: any): OrganizationsResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationsResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.organzations)) {
      data['organzations'] = [];
      for (let item of this.organzations)
        data['organzations'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }

  clone(): OrganizationsResponseDto {
    const json = this.toJSON();
    let result = new OrganizationsResponseDto();
    result.init(json);
    return result;
  }
}

export interface IOrganizationsResponseDto {
  organzations: OrganizationDto[] | undefined;
  totalCount: number;
}

export class PatientRequestDto implements IPatientRequestDto {
  id!: number;
  firstName!: string | undefined;
  lastName!: string | undefined;
  email!: string | undefined;
  phoneNumber!: string | undefined;
  dateOfBirth!: moment.Moment;
  gender!: string | undefined;
  street!: string | undefined;
  houseNumber!: string | undefined;
  postalCode!: string | undefined;
  city!: string | undefined;
  healthInsuranceTypeId!: number;
  healthInsuranceOrOther!: string | undefined;
  dateOfDischarge!: moment.Moment;
  modeOfConsumptionId!: number | undefined;
  kcal!: number;
  products!: string | undefined;
  healthInsuranceProviderID!: number | undefined;
  insuranceNumber!: string | undefined;
  generalPractioner!: string | undefined;
  comments!: string | undefined;
  diagnosis!: string | undefined;
  allergies!: string | undefined;
  height!: number;
  weight!: number;
  patientEmailID!: string | undefined;
  nursingService!: string | undefined;
  carer!: string | undefined;
  nursingHome!: string | undefined;
  informationAboutTube!: string | undefined;
  isInformedAndConsented!: boolean;
  healthInsuranceType!: string | undefined;
  modeOfConsumption!: string | undefined;
  healthInsuranceProvider!: string | undefined;

  constructor(data?: IPatientRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.email = _data['email'];
      this.phoneNumber = _data['phoneNumber'];
      this.dateOfBirth = _data['dateOfBirth']
        ? moment(_data['dateOfBirth'].toString())
        : <any>undefined;
      this.gender = _data['gender'];
      this.street = _data['street'];
      this.houseNumber = _data['houseNumber'];
      this.postalCode = _data['postalCode'];
      this.city = _data['city'];
      this.healthInsuranceTypeId = _data['healthInsuranceTypeId'];
      this.healthInsuranceOrOther = _data['healthInsuranceOrOther'];
      this.dateOfDischarge = _data['dateOfDischarge']
        ? moment(_data['dateOfDischarge'].toString())
        : <any>undefined;
      this.modeOfConsumptionId = _data['modeOfConsumptionId'];
      this.kcal = _data['kcal'];
      this.products = _data['products'];
      this.healthInsuranceProviderID = _data['healthInsuranceProviderID'];
      this.insuranceNumber = _data['insuranceNumber'];
      this.generalPractioner = _data['generalPractioner'];
      this.comments = _data['comments'];
      this.diagnosis = _data['diagnosis'];
      this.allergies = _data['allergies'];
      this.height = _data['height'];
      this.weight = _data['weight'];
      this.patientEmailID = _data['patientEmailID'];
      this.nursingService = _data['nursingService'];
      this.carer = _data['carer'];
      this.nursingHome = _data['nursingHome'];
      this.informationAboutTube = _data['informationAboutTube'];
      this.isInformedAndConsented = _data['isInformedAndConsented'];
      this.healthInsuranceType = _data['healthInsuranceType'];
      this.modeOfConsumption = _data['modeOfConsumption'];
      this.healthInsuranceProvider = _data['healthInsuranceProvider'];
    }
  }

  static fromJS(data: any): PatientRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new PatientRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['email'] = this.email;
    data['phoneNumber'] = this.phoneNumber;
    data['dateOfBirth'] = this.dateOfBirth
      ? this.dateOfBirth.toISOString()
      : <any>undefined;
    data['gender'] = this.gender;
    data['street'] = this.street;
    data['houseNumber'] = this.houseNumber;
    data['postalCode'] = this.postalCode;
    data['city'] = this.city;
    data['healthInsuranceTypeId'] = this.healthInsuranceTypeId;
    data['healthInsuranceOrOther'] = this.healthInsuranceOrOther;
    data['dateOfDischarge'] = this.dateOfDischarge
      ? this.dateOfDischarge.toISOString()
      : <any>undefined;
    data['modeOfConsumptionId'] = this.modeOfConsumptionId;
    data['kcal'] = this.kcal;
    data['products'] = this.products;
    data['healthInsuranceProviderID'] = this.healthInsuranceProviderID;
    data['insuranceNumber'] = this.insuranceNumber;
    data['generalPractioner'] = this.generalPractioner;
    data['comments'] = this.comments;
    data['diagnosis'] = this.diagnosis;
    data['allergies'] = this.allergies;
    data['height'] = this.height;
    data['weight'] = this.weight;
    data['patientEmailID'] = this.patientEmailID;
    data['nursingService'] = this.nursingService;
    data['carer'] = this.carer;
    data['nursingHome'] = this.nursingHome;
    data['informationAboutTube'] = this.informationAboutTube;
    data['isInformedAndConsented'] = this.isInformedAndConsented;
    data['healthInsuranceType'] = this.healthInsuranceType;
    data['modeOfConsumption'] = this.modeOfConsumption;
    data['healthInsuranceProvider'] = this.healthInsuranceProvider;
    return data;
  }

  clone(): PatientRequestDto {
    const json = this.toJSON();
    let result = new PatientRequestDto();
    result.init(json);
    return result;
  }
}

export interface IPatientRequestDto {
  id: number;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  phoneNumber: string | undefined;
  dateOfBirth: moment.Moment;
  gender: string | undefined;
  street: string | undefined;
  houseNumber: string | undefined;
  postalCode: string | undefined;
  city: string | undefined;
  healthInsuranceTypeId: number;
  healthInsuranceOrOther: string | undefined;
  dateOfDischarge: moment.Moment;
  modeOfConsumptionId: number | undefined;
  kcal: number;
  products: string | undefined;
  healthInsuranceProviderID: number | undefined;
  insuranceNumber: string | undefined;
  generalPractioner: string | undefined;
  comments: string | undefined;
  diagnosis: string | undefined;
  allergies: string | undefined;
  height: number;
  weight: number;
  patientEmailID: string | undefined;
  nursingService: string | undefined;
  carer: string | undefined;
  nursingHome: string | undefined;
  informationAboutTube: string | undefined;
  isInformedAndConsented: boolean;
  healthInsuranceType: string | undefined;
  modeOfConsumption: string | undefined;
  healthInsuranceProvider: string | undefined;
}

export class ReferralPatientLogDto implements IReferralPatientLogDto {
  id!: number;
  log!: string | undefined;
  createdAt!: moment.Moment;
  referralPatientId!: number | undefined;
  referralPatientName!: string | undefined;
  refererName!: string | undefined;
  cleverStatusId!: number | undefined;
  cleverStatus!: string | undefined;
  retryCount!: number | undefined;

  constructor(data?: IReferralPatientLogDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.log = _data['log'];
      this.createdAt = _data['createdAt']
        ? moment(_data['createdAt'].toString())
        : <any>undefined;
      this.referralPatientId = _data['referralPatientId'];
      this.referralPatientName = _data['referralPatientName'];
      this.refererName = _data['refererName'];
      this.cleverStatusId = _data['cleverStatusId'];
      this.cleverStatus = _data['cleverStatus'];
      this.retryCount = _data['retryCount'];
    }
  }

  static fromJS(data: any): ReferralPatientLogDto {
    data = typeof data === 'object' ? data : {};
    let result = new ReferralPatientLogDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['log'] = this.log;
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined;
    data['referralPatientId'] = this.referralPatientId;
    data['referralPatientName'] = this.referralPatientName;
    data['refererName'] = this.refererName;
    data['cleverStatusId'] = this.cleverStatusId;
    data['cleverStatus'] = this.cleverStatus;
    data['retryCount'] = this.retryCount;
    return data;
  }

  clone(): ReferralPatientLogDto {
    const json = this.toJSON();
    let result = new ReferralPatientLogDto();
    result.init(json);
    return result;
  }
}

export interface IReferralPatientLogDto {
  id: number;
  log: string | undefined;
  createdAt: moment.Moment;
  referralPatientId: number | undefined;
  referralPatientName: string | undefined;
  refererName: string | undefined;
  cleverStatusId: number | undefined;
  cleverStatus: string | undefined;
  retryCount: number | undefined;
}

export class ResetPasswordRequestDto implements IResetPasswordRequestDto {
  emailAddress!: string | undefined;
  oldPassword!: string | undefined;
  newPassword!: string | undefined;

  constructor(data?: IResetPasswordRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data['emailAddress'];
      this.oldPassword = _data['oldPassword'];
      this.newPassword = _data['newPassword'];
    }
  }

  static fromJS(data: any): ResetPasswordRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new ResetPasswordRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['emailAddress'] = this.emailAddress;
    data['oldPassword'] = this.oldPassword;
    data['newPassword'] = this.newPassword;
    return data;
  }

  clone(): ResetPasswordRequestDto {
    const json = this.toJSON();
    let result = new ResetPasswordRequestDto();
    result.init(json);
    return result;
  }
}

export interface IResetPasswordRequestDto {
  emailAddress: string | undefined;
  oldPassword: string | undefined;
  newPassword: string | undefined;
}

export class ResetPasswordRequestWithTokenDto
  implements IResetPasswordRequestWithTokenDto
{
  emailAddress!: string | undefined;
  password!: string | undefined;
  resetToken!: string | undefined;

  constructor(data?: IResetPasswordRequestWithTokenDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data['emailAddress'];
      this.password = _data['password'];
      this.resetToken = _data['resetToken'];
    }
  }

  static fromJS(data: any): ResetPasswordRequestWithTokenDto {
    data = typeof data === 'object' ? data : {};
    let result = new ResetPasswordRequestWithTokenDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['emailAddress'] = this.emailAddress;
    data['password'] = this.password;
    data['resetToken'] = this.resetToken;
    return data;
  }

  clone(): ResetPasswordRequestWithTokenDto {
    const json = this.toJSON();
    let result = new ResetPasswordRequestWithTokenDto();
    result.init(json);
    return result;
  }
}

export interface IResetPasswordRequestWithTokenDto {
  emailAddress: string | undefined;
  password: string | undefined;
  resetToken: string | undefined;
}

export class UserProfileDto implements IUserProfileDto {
  firstName!: string | undefined;
  lastName!: string | undefined;
  displayName!: string | undefined;
  emailId!: string | undefined;
  phoneNumber!: string | undefined;
  isPhoneNumberVerified!: boolean;
  defaultRole!: string | undefined;
  dateCreated!: moment.Moment;
  currentChallenge!: string | undefined;
  isMpaTypeActivated!: boolean;
  avatarUrl!: string | undefined;
  isEmailVerified!: boolean;
  lastSeenDate!: moment.Moment | undefined;
  organizationId!: number;
  organizationName!: string | undefined;
  isOrgOTPApplicable!: boolean;
  isUserOTPApplicable!: boolean;

  constructor(data?: IUserProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.displayName = _data['displayName'];
      this.emailId = _data['emailId'];
      this.phoneNumber = _data['phoneNumber'];
      this.isPhoneNumberVerified = _data['isPhoneNumberVerified'];
      this.defaultRole = _data['defaultRole'];
      this.dateCreated = _data['dateCreated']
        ? moment(_data['dateCreated'].toString())
        : <any>undefined;
      this.currentChallenge = _data['currentChallenge'];
      this.isMpaTypeActivated = _data['isMpaTypeActivated'];
      this.avatarUrl = _data['avatarUrl'];
      this.isEmailVerified = _data['isEmailVerified'];
      this.lastSeenDate = _data['lastSeenDate']
        ? moment(_data['lastSeenDate'].toString())
        : <any>undefined;
      this.organizationId = _data['organizationId'];
      this.organizationName = _data['organizationName'];
      this.isOrgOTPApplicable = _data['isOrgOTPApplicable'];
      this.isUserOTPApplicable = _data['isUserOTPApplicable'];
    }
  }

  static fromJS(data: any): UserProfileDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['displayName'] = this.displayName;
    data['emailId'] = this.emailId;
    data['phoneNumber'] = this.phoneNumber;
    data['isPhoneNumberVerified'] = this.isPhoneNumberVerified;
    data['defaultRole'] = this.defaultRole;
    data['dateCreated'] = this.dateCreated
      ? this.dateCreated.toISOString()
      : <any>undefined;
    data['currentChallenge'] = this.currentChallenge;
    data['isMpaTypeActivated'] = this.isMpaTypeActivated;
    data['avatarUrl'] = this.avatarUrl;
    data['isEmailVerified'] = this.isEmailVerified;
    data['lastSeenDate'] = this.lastSeenDate
      ? this.lastSeenDate.toISOString()
      : <any>undefined;
    data['organizationId'] = this.organizationId;
    data['organizationName'] = this.organizationName;
    data['isOrgOTPApplicable'] = this.isOrgOTPApplicable;
    data['isUserOTPApplicable'] = this.isUserOTPApplicable;
    return data;
  }

  clone(): UserProfileDto {
    const json = this.toJSON();
    let result = new UserProfileDto();
    result.init(json);
    return result;
  }
}

export interface IUserProfileDto {
  firstName: string | undefined;
  lastName: string | undefined;
  displayName: string | undefined;
  emailId: string | undefined;
  phoneNumber: string | undefined;
  isPhoneNumberVerified: boolean;
  defaultRole: string | undefined;
  dateCreated: moment.Moment;
  currentChallenge: string | undefined;
  isMpaTypeActivated: boolean;
  avatarUrl: string | undefined;
  isEmailVerified: boolean;
  lastSeenDate: moment.Moment | undefined;
  organizationId: number;
  organizationName: string | undefined;
  isOrgOTPApplicable: boolean;
  isUserOTPApplicable: boolean;
}

export class UserProfileResponseDto implements IUserProfileResponseDto {
  userId!: number;
  firstName!: string | undefined;
  lastName!: string | undefined;
  emailAddress!: string | undefined;
  organizationId!: number;
  organizationName!: string | undefined;
  isOrgOTPApplicable!: boolean;
  isUserOTPApplicable!: boolean;
  userRoleId!: number;
  roleName!: string | undefined;

  constructor(data?: IUserProfileResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.emailAddress = _data['emailAddress'];
      this.organizationId = _data['organizationId'];
      this.organizationName = _data['organizationName'];
      this.isOrgOTPApplicable = _data['isOrgOTPApplicable'];
      this.isUserOTPApplicable = _data['isUserOTPApplicable'];
      this.userRoleId = _data['userRoleId'];
      this.roleName = _data['roleName'];
    }
  }

  static fromJS(data: any): UserProfileResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserProfileResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['emailAddress'] = this.emailAddress;
    data['organizationId'] = this.organizationId;
    data['organizationName'] = this.organizationName;
    data['isOrgOTPApplicable'] = this.isOrgOTPApplicable;
    data['isUserOTPApplicable'] = this.isUserOTPApplicable;
    data['userRoleId'] = this.userRoleId;
    data['roleName'] = this.roleName;
    return data;
  }

  clone(): UserProfileResponseDto {
    const json = this.toJSON();
    let result = new UserProfileResponseDto();
    result.init(json);
    return result;
  }
}

export interface IUserProfileResponseDto {
  userId: number;
  firstName: string | undefined;
  lastName: string | undefined;
  emailAddress: string | undefined;
  organizationId: number;
  organizationName: string | undefined;
  isOrgOTPApplicable: boolean;
  isUserOTPApplicable: boolean;
  userRoleId: number;
  roleName: string | undefined;
}

export class UserRegistrationDto implements IUserRegistrationDto {
  firstName!: string | undefined;
  lastName!: string | undefined;
  emailAddress!: string | undefined;
  organizationId!: number;
  phoneNumber!: string | undefined;
  password!: string | undefined;

  constructor(data?: IUserRegistrationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.emailAddress = _data['emailAddress'];
      this.organizationId = _data['organizationId'];
      this.phoneNumber = _data['phoneNumber'];
      this.password = _data['password'];
    }
  }

  static fromJS(data: any): UserRegistrationDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserRegistrationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['emailAddress'] = this.emailAddress;
    data['organizationId'] = this.organizationId;
    data['phoneNumber'] = this.phoneNumber;
    data['password'] = this.password;
    return data;
  }

  clone(): UserRegistrationDto {
    const json = this.toJSON();
    let result = new UserRegistrationDto();
    result.init(json);
    return result;
  }
}

export interface IUserRegistrationDto {
  firstName: string | undefined;
  lastName: string | undefined;
  emailAddress: string | undefined;
  organizationId: number;
  phoneNumber: string | undefined;
  password: string | undefined;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else
    return _observableThrow(
      new ApiException(message, status, response, headers, null)
    );
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
